export default __webpack_public_path__ + "static/media/wreckingball.8bf7859e.webp";